console.log("PopClub 0.49.0");

// Body Function
window.addEventListener('click', function (event5) {
  if (event5.target == document.getElementById('myModal3')) {
    document.getElementById('myModal3').style.display = "none";
    let buyWithCoinsSpinner3 = document.getElementById("pop-spinner3");
    buyWithCoinsSpinner3.classList.add("hidden");
    document.getElementById("pop-club-quick-buy3").disabled = false;
    document.body.classList.remove('popcoinShow');
    popPrices();
  }
  if (event5.target == document.getElementById('myModal2')) {
    document.getElementById('myModal2').style.display = "none";
    let buyWithCoinsSpinner2 = document.getElementById("pop-spinner2");
    buyWithCoinsSpinner2.classList.add("hidden");
    document.getElementById("pop-club-quick-buy2").disabled = false;
    document.body.classList.remove('popcoinShow');
    popPrices();
  }
})

// Cart Drawer Discount Coupon Create
function createPopDiscounttCart() {

  // Removing the Coupon Code
  document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";

  // Enable Loader
  document.querySelector('.gokwik-checkout button').setAttribute('disabled', '');
  document.querySelectorAll('.gokwik-checkout button span').forEach((el) => {
    el.classList.add('hidden');
  });
  document.querySelector('.gokwik-checkout button div').style.display = "block";

  // Shopify Ajax Cart API
  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((data) => {

      let key = document.cookie
      .split('; ')
      .find((row) => row.startsWith('_shopify_s='))
      ?.split('=')[1];

      let price_len = (data['items_subtotal_price'].toString().length) - 2;
      let price = data['items_subtotal_price'].toString().slice(0, price_len) + "." + data['items_subtotal_price'].toString().slice(price_len);
      let variants = '';

      for (let data_var of data['items']) {
        variants += data_var['variant_id'] + '-' + data_var['quantity'] + ',';
      }

      let parameters = '?cart=' + price + '&shop=' + Shopify.shop + '&key=' + key + '&variants=' + variants;
      if (document.querySelector('.pop_club_cart #buy-with-pop-coins').checked) {
        fetch('https://prodreplica.mypopcoins.com/api/get-coins-cart-discount' + parameters)
          .then((response) => response.json())
          .then((data) => {
            if (data.success == true) {
              const date = new Date();
              date.setTime(date.getTime() + (60 * 60 * 1000));
              const expires = '; expires=' + date.toUTCString();
              document.cookie = `discount_code=${data.code}${expires}; path=/`;
            }
          });
      }
      else {
        document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
      }

      setTimeout(() => {
        // Removing Loader
        document.querySelector('.gokwik-checkout button').removeAttribute('disabled');
        document.querySelectorAll('.gokwik-checkout button span').forEach((el) => {
          el.classList.remove('hidden');
        });

        document.querySelector('.gokwik-checkout button div').style.display = "none";
      }, 2500);

    });
}

function quickPop() {
  fetch('https://prodreplica.mypopcoins.com/api/get-brand?shop=' + Shopify.shop)
    .then((response) => response.json())
    .then((data) => {
      let key = document.cookie
        .split('; ')
        .find((row) => row.startsWith('_shopify_s='))
        ?.split('=')[1];
      // var popupPdp = document.getElementById("pop-club-product-detail-modal");
      var popupPdp = document.querySelector(".modal--is-active #pop-club-product-detail-modal");
      // console.log('ashish1')
      if (popupPdp) {
        // console.log('ashish2')

        let price2 = popupPdp.getAttribute("price");
        console.log('ashish', price2);
        var priceValue2 = Math.floor(price2);
        if (priceValue2.toString().length > 2) {
          var modulePrice2 = priceValue2 % 100;
          var roundedPrice2 = priceValue2 - modulePrice2;
        }
        else {
          var roundedPrice2 = 0;
        }
        let issueCoins2 = Math.round((data.issuance / 100) * roundedPrice2);
        popHTML2 = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png' width='20' height='21'> </span> " + issueCoins2 + " on this product <img class='info-popup-coin' src='https://d20pzmflnl47dv.cloudfront.net/media/icon-i.png' onclick=openLoadedIframe()></p>";

        popupPdp.innerHTML = '';
        popupPdp.innerHTML = popHTML2;
      }
    })
}

function popcoinPopup() {
  let queryString = window.location.search;
  if (queryString.includes('coins=true') || queryString.includes('coins=TRUE')) {
    fetch('https://prodreplica.mypopcoins.com/api/get-brand?shop=' + Shopify.shop)
      .then((response) => response.json())
      .then((data) => {
        document.getElementById("pop-club-iframe-url").value = data.iframe_url;
        console.log('modal opned')
        let key = document.cookie
        .split('; ')
        .find((row) => row.startsWith('_shopify_s='))
        ?.split('=')[1];
        openLoadedIframe();
      });
  }
}
popcoinPopup();

function popCheck() {
  let buyWithPop = document.getElementById("buy-with-pop-coins");
  if (buyWithPop) {
    buyWithPop.onclick = function () {
      checkedPopup();
    };
  }
}

// Refresh, Onload Function 
function popPrices() {
  fetch('https://prodreplica.mypopcoins.com/api/get-brand?shop=' + Shopify.shop)
    .then((response) => response.json())
    .then((data) => {

      redeemCoins = data.coins;
      //Set URL of iframe
      document.querySelector("#pop-club-iframe-url").value = data.iframe_url;

      console.log('cart data added');
      cartDatas(data);

      let key = document.cookie
        .split('; ')
        .find((row) => row.startsWith('_shopify_s='))
        ?.split('=')[1];

      parameters = '?shop=' + Shopify.shop + '&key=' + key;
      fetch('https://prodreplica.mypopcoins.com/api/get-available-coins' + parameters)
        .then((response) => response.json())
        .then((data2) => {
          let pop_cart_div = document.querySelector('.pop_club_cart');
          if (data2.success == false) {
            pop_cart_div.querySelector("#buy-with-pop-coins").style.display = "none";
          } else {
            pop_cart_div.querySelector("#buy-with-pop-coins").style.display = "block";
          }

          if (data2.avaiable == false) {
            const popClubBuyNow = document.querySelector("#pop-club-quick-buy");
            popClubBuyNow.setAttribute("disabled", "true");
          }

          if (data2.success == true) {
            document.querySelector("#pop-club-login-flag").value = "true";
            document.querySelector("#pop-club-redeem-price").value = data2.coins;
          } else {
            document.querySelector("#pop-club-login-flag").value = "false";
          }

          var popClubDiv = document.getElementsByClassName("pop-club-listing");
          for (let pop_price_div of popClubDiv) {

            let price = pop_price_div.getAttribute("price");

            let redeemCoins = Math.round((data.redeem / 100) * price);
            if (redeemCoins > data2.coins && data2.success == true) {
              redeemCoins = data2.coins;
            }
            let redeemPrice = Math.round(price - redeemCoins);
            if (redeemCoins == 0) {
              let popHTML = "";
              pop_price_div.innerHTML = popHTML;
            }
            else {
              let popHTML = `<p><span class="popcoin_msg">or<span> <span style="display: flex;">Rs. ${redeemPrice} + <span class='pop-img'><img src='https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png'></span> ${redeemCoins} </span></p>`;
              pop_price_div.innerHTML = popHTML;
            }

          }

          var popClubProductDiv = document.querySelector("#pop-club-product-detail");
          var popClubProductBuySpan = document.querySelector("#pop-club-quick-buy-span");
          document.querySelector("#pop-club-data-redeem").value = data.redeem;
          document.querySelector("#pop-club-data-coins").value = data2.coins;
          if (popClubProductDiv) {
            let price = popClubProductDiv.getAttribute("price");

            let redeemCoins = Math.round((data.redeem / 100) * price);
            document.querySelector("#pop-club-redeem-price").value = redeemCoins;
            if (redeemCoins > data2.coins && data2.success == true) {
              redeemCoins = data2.coins;
              document.querySelector("#pop-club-data-coins").value = data2.coins;
              document.querySelector("#pop-club-redeem-price").value = redeemCoins;
            }
            let redeemPrice = Math.round(price - redeemCoins);
            popClubProductBuySpan.innerHTML = "BUY USING Rs. " + redeemPrice + " + <span class='pop-img'> <img src='https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png'> </span> " + redeemCoins;

            var priceValue = Math.floor(price);
            if (priceValue.toString().length > 2) {
              var modulePrice = priceValue % 100;
              var roundedPrice = priceValue - modulePrice;
            }
            else {
              var roundedPrice = 0;
            }
            let pdp_qty = parseInt(document.querySelector('.qtyField #quantity').value);
            let issueCoins = Math.round((data.issuance / 100) * roundedPrice) * pdp_qty;
            popHTML = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png' width='20' height='21'> </span> " + issueCoins + " on this product <img class='info-popup-coin' src='https://d20pzmflnl47dv.cloudfront.net/media/icon-i.png' onclick=openLoadedIframe()></p>";

            if (data2.success == true && window.location.href.includes('/products') == true) {
              if (data2.coins == 0) {
                document.querySelector('.pdp_popcoin').classList.add('hidden');
              }
              else {
                document.querySelector('.pdp_popcoin').classList.remove('hidden');
              }
              let pdp_max_coin = Math.min(Math.round(pdp_qty * parseInt(price) * 0.3), data2.coins);
              document.querySelector('.pdp_popcoin #buy-with-pop-coins-label').innerHTML = 'Rs. ' + pdp_max_coin + ' | Save Using POPcoins';
              document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
              document.querySelector('.pdp_popcoin #buy-with-pop-coins').checked = false;
            }
            else {
              document.querySelector('.pdp_popcoin').classList.add('hidden');
            }

            let productIssuanceMsg = document.getElementById("product-issuance-msg");
            if (productIssuanceMsg) {
              popClubProductDiv.innerHTML = popHTML;
            } else {
              popClubProductDiv.insertAdjacentHTML("afterbegin", popHTML);
            }
            //Stripe Dynamic 
            if (data2.avaiable == true) {
              var popClubStripe = document.querySelector("#pop-club-quick-buy-span-stripe");
              redeemCoins = data2.coins;
              if (redeemCoins == 0) {
                document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = 'none';
                let popHTMLStripe1 = '<div class="popcoin_sec1"><img width="30" height="30" src="https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png">' + redeemCoins + '</div>Shop, earn POPcoins and get rewarded <img class="arrow" width="19" height="16" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
                popClubStripe.innerHTML = popHTMLStripe1;
              }
              else {
                let popHTMLStripe2 = '<span class="saaki_royal">SOHI Loyalty Rewards</span>Get upto 30% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png">' + redeemCoins + '</div><img class="arrow" width="19" height="16" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
                popClubStripe.innerHTML = popHTMLStripe2;
              }
            }
          }
          else {
            redeemCoins = data2.coins;
            if (data2.avaiable == true) {
              var popClubStripe = document.querySelector("#pop-club-quick-buy-span-stripe");
              if (redeemCoins == 0) {
                document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = 'none';
                let popHTMLStripe3 = '<div class="popcoin_sec"><img width="30" height="30" src="https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png">' + redeemCoins + '</div>Shop, earn POPcoins and get rewarded <img class="arrow" width="19" height="16" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
                popClubStripe.innerHTML = popHTMLStripe3;
              }
              else {
                let popHTMLStripe4 = '<span class="saaki_royal">SOHI Loyalty Rewards</span>Get upto 30% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png">' + redeemCoins + '</div><img class="arrow" width="19" height="16" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
                popClubStripe.innerHTML = popHTMLStripe4;
              }
            }

          }

          if (window.location.href.includes('/products') == true && parseInt(data2.coins) > 0 && data2.success == true) {
            let price = parseInt(document.querySelector('.product-single__price .product-price__price .product--price').getAttribute('price'));
            let pdp_qty = parseInt(document.querySelector('.qtyField #quantity').value);
            let pdp_max_coin = Math.min(Math.round(pdp_qty * parseInt(price) * 0.3), data2.coins);
            let strip_new_str = '<span class="saaki_royal">POPcoins discount will be applied at the cart</span>';
            document.querySelector('#pop-club-quick-buy-span-stripe').innerHTML = strip_new_str;
          }

          // api -- get-brands, getavaiable coins
          subTotal(data, data2);
        });
    });
}

//End --- Pop Coins Pricing

//Start --- Buy with Pop Coins
const popClubBuyNow = document.getElementById("pop-club-quick-buy");
if (popClubBuyNow) {
  popClubBuyNow.addEventListener("click", function (e) {
    this.setAttribute("disabled", "true");
    displayPopSpinner();
    createPopCheckout();
  });
}
//End --- Buy with Pop Coins

function displayPopSpinner() {
  let buyWithCoinsSpinner = document.getElementById("pop-spinner");
  buyWithCoinsSpinner.classList.remove("hidden");
}

function removePopSpinner() {
  const popClubBuyNow = document.getElementById("pop-club-quick-buy");
  if (popClubBuyNow) {
    popClubBuyNow.removeAttribute("disabled");
  }
  const buyWithCoinsSpinner = document.getElementById("pop-spinner");
  if (buyWithCoinsSpinner) {
    buyWithCoinsSpinner.classList.add("hidden");
  }
}

function openPopModal() {
  let popClubModel = document.getElementById("myModal");
  popClubModel.style.display = "block";
}

function closePopModal() {
  popClubModel.style.display = "none";
}

if (window.location.href.indexOf("/cart") != -1) {
  popCheck();
  checkOutCart();
}

function createPopCheckout() {
  let variantId = document.getElementById("pop-club-product-id");
  let quantity = document.getElementsByName("quantity");
  let key = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_shopify_s='))
    ?.split('=')[1];

  parameters = '?variant=' + variantId.value + '&shop=' + Shopify.shop + '&key=' + key + '&quantity=' + quantity[0].value;
  fetch('https://prodreplica.mypopcoins.com/api/get-coins' + parameters)
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      removePopSpinner();
      if (data.success == true) {
        window.location = data.url;
      } else if (data.success == false) {
        openLoadedIframe();
      }
    });

}

function createPopCheckoutCart() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((data) => {
      let key = document.cookie
        .split('; ')
        .find((row) => row.startsWith('_shopify_s='))
        ?.split('=')[1];

      let price_len = (data['items_subtotal_price'].toString().length) - 2;
      let price = data['items_subtotal_price'].toString().slice(0, price_len) + "." + data['items_subtotal_price'].toString().slice(price_len);
      let variants = '';
      for (let data_var of data['items']) {
        variants += data_var['variant_id'] + '-' + data_var['quantity'] + ',';
      }

      let parameters = '?cart=' + price + '&shop=' + Shopify.shop + '&key=' + key + '&variants=' + variants;
      fetch('https://prodreplica.mypopcoins.com/api/get-coins-cart' + parameters)
        .then((response) => response.json())
        .then((data) => {
          if (data.success == true) {
            window.location = data.url;
          } else if (data.success == false) {
            openLoadedIframe();
          }
        });

    });

}

function checkedPopup() {
  let key = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_shopify_s='))
    ?.split('=')[1];

  if (document.getElementById("pop-club-login-flag").value == 'true') {
    let checkpopup = document.getElementById("buy-with-pop-coins");
    if (checkpopup.checked == true) {
      // createPopCheckoutCart();
    }
  } else {
    let checkpopup = document.getElementById("buy-with-pop-coins");
    if (checkpopup.checked == true) {
      openLoadedIframe();
    }
  }

  subTotalSecond();
}

function subTotal(data, data2) {

  let key = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_shopify_s='))
    ?.split('=')[1];

  var name1 = '_shopify_s';

  let parameters = '?shop=' + Shopify.shop + '&key=' + key;
  var popClubProductDiv = document.querySelector(".pop_club_cart #buy-with-pop-coins-label");
  if (popClubProductDiv) {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((cartData) => {

        let price_len = (cartData['items_subtotal_price'].toString().length) - 2;
        let price = cartData['items_subtotal_price'].toString().slice(0, price_len) + "." + cartData['items_subtotal_price'].toString().slice(price_len);

        let redeemCoins = Math.round((data.redeem / 100) * price);
        let redeemPrice = Math.round(price - redeemCoins);

        if (redeemCoins > data2.coins && data2.success == true) {
          redeemCoins = data2.coins;
        }
        if (data2.success == true) {
          let checkpopup = document.getElementById("buy-with-pop-coins");
          document.getElementById("buy-with-pop-coins").style.display = "inline-block"; 
          if (checkpopup.checked == true) {

            if (redeemCoins == 0) {
              document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = "none";
              popHTML = "You have 0 POPcoins. Shop now & earn coins.";
              document.getElementById("buy-with-pop-coins").checked = false;
            }
            else {
              document.getElementById("buy-with-pop-coins").style.display = "inline-block"; 
              popHTML = "Rs. " + redeemCoins + " | Saved using POPcoins";
            }
          }
          else {
            if (redeemCoins == 0) {
              document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = "none";
              popHTML = "You have 0 POPcoins. Shop now & earn coins.";
              document.getElementById("buy-with-pop-coins").checked = false;
            }
            else {
              document.getElementById("buy-with-pop-coins").style.display = "inline-block"; 
              // a big headech
              popHTML = "Rs. " + redeemCoins + " | Save using POPcoins";
            }
          }
        }
        else {
          document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = "none";
          popHTML = '<span class="underline" onclick="openLoadedIframe()"><span class="hyperlink-style">Click</span> & get upto 30% off using POPcoins</span>';
          document.getElementById("buy-with-pop-coins").checked = false;
        }

        popClubProductDiv.innerHTML = popHTML;

      });

  }

}

function subTotalSecond() {

  let key = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_shopify_s='))
    ?.split('=')[1];
  let parameters = '?shop=' + Shopify.shop + '&key=' + key;
  
  var popClubProductDiv = document.getElementById("buy-with-pop-coins-label");
  if (popClubProductDiv) {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((cartData) => {
        let price_len = (cartData['items_subtotal_price'].toString().length) - 2;
        let price = cartData['items_subtotal_price'].toString().slice(0, price_len) + "." + cartData['items_subtotal_price'].toString().slice(price_len);
        let dataRedeem = document.getElementById("pop-club-data-redeem").value;
        let dataCoins = document.getElementById("pop-club-data-coins").value;
        let redeemCoins = Math.round((dataRedeem / 100) * price);
        let redeemPrice = Math.round(price - redeemCoins);

        if (redeemCoins > dataCoins && document.getElementById("pop-club-login-flag").value == 'true') {
          redeemCoins = dataCoins;
        }
        if (document.getElementById("pop-club-login-flag").value == 'true') {

          let checkpopup = document.getElementById("buy-with-pop-coins");
          document.getElementById("buy-with-pop-coins").style.display = "inline-block"; 
          if (checkpopup.checked == true) {

            if (redeemCoins == 0) {
              document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = "none";
              popHTML = "You have 0 POPcoins. Shop now & earn coins.";
              document.getElementById("buy-with-pop-coins").checked = false;
            }
            else {
              document.getElementById("buy-with-pop-coins").style.display = "inline-block"; 
              popHTML = "Save Rs. " + redeemCoins + " using POPcoins";
            }

          }
          else {
            if (redeemCoins == 0) {
              document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = "none";
              popHTML = "You have 0 POPcoins. Shop now & earn coins.";
              document.getElementById("buy-with-pop-coins").checked = false;
            }
            else {
              document.getElementById("buy-with-pop-coins").style.display = "inline-block";
              popHTML = "Save Rs. " + redeemCoins + " using POPcoins";
            }
          }
        }
        else {
          document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = "none";
          popHTML = '<span class="underline" onclick="openLoadedIframe()"><span class="hyperlink-style">Click</span> & get upto 30% off using POPcoins</span>';
          document.getElementById("buy-with-pop-coins").checked = false;
        }

        popClubProductDiv.innerHTML = popHTML;

      });

  }
}

function create(el) {
  var d = document;
  var element = d.createElement(el);
  element.classList.add("manual_class_cart__price_down");
  return element;
}

function cart_i_icon() {
  let key1 = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
  openLoadedIframe();
  document.querySelector('.back-to-top').classList.remove('hidden');
}

// To Create POPcoin Earn Call out for Cart Drawer
function cartDatas(data) {

  // Shopify Ajax Cart API 
  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((cartData) => {

      // InsertAfter Function
      function insertAfter(newNode, existingNode) {
        return new Promise((res, rej) => {
          res(existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling));
        })
      }

      var i = 0;
      // Cart Drawer
      (async function () {
        setTimeout(() => {
          document.querySelector("#cart-drawer").querySelectorAll(".grid.cart__item").forEach((item) => {

            let price_len = (cartData['items'][i].price.toString().length) - 2;
            let quantity = cartData['items'][i].quantity;
            let price = cartData['items'][i].price.toString().slice(0, price_len) + "." + cartData['items'][i].price.toString().slice(price_len);

            i++;
            var priceValue = Math.floor(price);
            if (priceValue.toString().length > 2) {
              var modulePrice = priceValue % 100;
              var roundedPrice = priceValue - modulePrice;
            }
            else {
              var roundedPrice = 0;
            }

            var issueCoins = Math.round(((data.issuance / 100) * roundedPrice) * quantity);
            var newstring = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png' width='20' height='21'> </span> " + issueCoins + " <img class='info-popup-coin1' src='https://d20pzmflnl47dv.cloudfront.net/media/icon-i.png' onclick=openLoadedIframe();></p>";

            if (item.querySelector(".product-details .manual_class_cart__price_down") != null) {
              item.querySelectorAll(".product-details .manual_class_cart__price_down").forEach((old_item) => {
                old_item.remove();
              });
            }

            insertAfter(create("div"), item.querySelector(".product-details .priceRow")).then(() => {
              item.querySelector(".product-details .manual_class_cart__price_down").innerHTML = '';
              item.querySelector(".product-details .manual_class_cart__price_down").innerHTML = newstring;
            })

          })
        }, 2000);
      })();

      // Cart Page
      var j = 0;
      document.querySelectorAll("#CartDrawer-Form .grid.cart__item").forEach((item) => {
        console.log('cart page testing');
        let price_len = (cartData['items'][j].price.toString().length) - 2;
        let quantity = cartData['items'][j].quantity;
        let price = cartData['items'][j].price.toString().slice(0, price_len) + "." + cartData['items'][i].price.toString().slice(price_len);
        j++;
        var priceValue = Math.floor(price);
        if (priceValue.toString().length > 2) {
          var modulePrice = priceValue % 100;
          var roundedPrice = priceValue - modulePrice;
        }
        else {
          var roundedPrice = 0;
        }
        var issueCoins = Math.round(((data.issuance / 100) * roundedPrice) * quantity);
        var newstring = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png'> </span> " + issueCoins + " <img class='info-popup-coin1' src='https://d20pzmflnl47dv.cloudfront.net/media/icon-i.png' onclick=openLoadedIframe();></p>";
        if (item.querySelector(".product-details .manual_class_cart__price_down") != null) {
          item.querySelectorAll(".product-details .manual_class_cart__price_down").forEach((old_item) => {
            old_item.remove();
          });
        }
        insertAfter(create("div"), item.querySelector(".product-details .priceRow")).then(() => {
          item.querySelector(".product-details .manual_class_cart__price_down").innerHTML = '';
          item.querySelector(".product-details .manual_class_cart__price_down").innerHTML = newstring;
        });
      });

    });
    let innerHtml = document.querySelector("#buy-with-pop-coins-label").innerHTML;
    if(innerHtml == 'Rs. 0 | Save Using POPcoins' ){
      console.log('FLV:DKF');
      document.querySelector(".minicartTol input#buy-with-pop-coins").style.display = "none";
    }

}

function checkout_input() {
  let pop_cart_div = document.querySelector('.pop_club_cart');
  pop_cart_div.querySelector('#buy-with-pop-coins').addEventListener('click', () => {
    pop_cart_div.querySelector('#buy-with-pop-coins').setAttribute('disabled', '');
    fetch('https://prodreplica.mypopcoins.com/api/get-available-coins' + parameters)
      .then((response) => response.json())
      .then(data => {
        if (!data.success) {
          document.querySelector('body').classList.remove('overflow-hidden');
          document.querySelector('#BackToTop').classList.remove('hidden');
          let key1 = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
          openLoadedIframe();
        }
        else {
          let subTotal = document.querySelector('#cart-drawer .minicartTol .product-price.cart-subtotal-price').getAttribute('cart_val');
          let totalPrice = subTotal.replace('Rs.', '');
          let cartSubTotal = totalPrice.replace(',', '');

          let total_value = cartSubTotal;
          total_value = parseInt(total_value);

          let pop_disc = pop_cart_div.querySelector('#buy-with-pop-coins-label').innerHTML.split('|')[0];
          pop_disc = parseInt(pop_disc.replace('Rs.', '').replace('₹', '').replace('.', ''));

          let pop_checkout_checked = pop_cart_div.querySelector('#buy-with-pop-coins').checked;
          let price_pop_val, cart_pop_last_str;

          if (pop_checkout_checked) {
            cart_pop_last_str = "Saved Using POPcoins";
            price_pop_val = 'Rs. ' + (total_value - pop_disc) + '.00';
          }
          else {
            cart_pop_last_str = "Save Using POPcoins";
            // here is the culprit
            price_pop_val = 'Save Rs. ' + (total_value) + '.00';
          }
          document.querySelector('#cart-drawer .minicartTol .product-price.cart-subtotal-price').innerHTML = price_pop_val;
          pop_cart_div.querySelector('#buy-with-pop-coins-label').innerHTML = 'Rs. ' + pop_disc + ' | ' + cart_pop_last_str;
        }
        pop_cart_div.querySelector('#buy-with-pop-coins').removeAttribute('disabled');
        createPopDiscounttCart();
      })
  });
}

// PDP Buy Fix
function pdp_buy_now() {
  if (window.location.href.includes('/products') == true) {

    let pdp_pop_div = document.querySelector('.pdp_popcoin');
    // Buy Now Button
    let key = document.cookie
      .split('; ')
      .find((row) => row.startsWith('_shopify_s='))
      ?.split('=')[1];
    let parameters = '?shop=' + Shopify.shop + '&key=' + key;
    fetch('https://prodreplica.mypopcoins.com/api/get-available-coins' + parameters)
      .then((response) => response.json())
      .then(data => {
        if (!data.success) {
          pdp_pop_div.classList.add('hidden');
        }
        else {
          pdp_pop_div.classList.remove('hidden');

          let coin_val = data.coins;
          let pdp_price = document.querySelector('.product-single__price .product-price__price .product--price').getAttribute('price');
          pdp_price = parseInt(pdp_price);

          let pdp_curr_pop_price = Math.min(Math.ceil((pdp_price * 30) / 100), coin_val);

          if (pdp_curr_pop_price == 0) {
            pdp_pop_div.classList.add('hidden');
          }
          else {
            pdp_pop_div.classList.remove('hidden');
          }

          let pdp_input_checked = pdp_pop_div.querySelector('#buy-with-pop-coins').checked;

          let pdp_pop_last_str;
          if (pdp_input_checked == true) {
            pdp_pop_last_str = "Saved Using POPcoins";

            let key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];

            let pdp_var_id = pdp_pop_div.querySelector('#buy-with-pop-coins').getAttribute('variant_id');
            let parameters = '?cart=' + pdp_curr_pop_price + '&shop=' + Shopify.shop + '&key=' + key + '&variants=' + pdp_var_id;

            fetch('https://prodreplica.mypopcoins.com/api/get-coins-cart-discount' + parameters)
              .then((response) => response.json())
              .then((data) => {
                const date = new Date();
                date.setTime(date.getTime() + (60 * 60 * 1000));
                const expires = '; expires=' + date.toUTCString();
                document.cookie = `discount_code=${data.code}${expires}; path=/`;
              });

          }
          else {
            pdp_pop_last_str = "Save Using POPcoins";
            document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
          }

          pdp_pop_div.querySelector('#buy-with-pop-coins-label').innerHTML = "Rs. " + pdp_curr_pop_price + ' | ' + pdp_pop_last_str;

        }

      });

      pdp_pop_div.querySelector('#buy-with-pop-coins').addEventListener('click', function () {

      // Enable PDP Loader
      document.querySelector('.xpresslane-button #gokwik-buy-now div').style.display = 'flex';
      document.querySelector('.xpresslane-button #gokwik-buy-now div').id = "btn-loader";
      document.querySelector('.xpresslane-button #gokwik-buy-now').setAttribute('disabled', '');

      let key = document.cookie
        .split('; ')
        .find((row) => row.startsWith('_shopify_s='))
        ?.split('=')[1];
      let parameters = '?shop=' + Shopify.shop + '&key=' + key;
      fetch('https://prodreplica.mypopcoins.com/api/get-available-coins' + parameters)
        .then((response) => response.json())
        .then(data => {
          if (!data.success) {
            pdp_pop_div.classList.add('hidden');
          }
          else {
            pdp_pop_div.classList.remove('hidden');

            let coin_val = data.coins;
            let pdp_price = document.querySelector('.product-single__price .product-price__price .product--price').getAttribute('price');
            pdp_price = parseInt(pdp_price);

            let pdp_qty = parseInt(document.querySelector('.qtyField #quantity').value);
            let pdp_curr_pop_price = Math.min(Math.ceil((pdp_price * 30) / 100) * pdp_qty, coin_val);

            if (pdp_curr_pop_price == 0) {
              pdp_pop_div.classList.add('hidden');
            }
            else {
              pdp_pop_div.classList.remove('hidden');
            }

            let pdp_input_checked = pdp_pop_div.querySelector('#buy-with-pop-coins').checked;

            let pdp_pop_last_str;
            if (pdp_input_checked == true) {
              pdp_pop_last_str = "Saved Using POPcoins";

              let key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];

              let pdp_var_id = pdp_pop_div.querySelector('#buy-with-pop-coins').getAttribute('variant_id');
              let parameters = '?cart=' + pdp_price + '&shop=' + Shopify.shop + '&key=' + key + '&variants=' + pdp_var_id;

              fetch('https://prodreplica.mypopcoins.com/api/get-coins-cart-discount' + parameters)
                .then((response) => response.json())
                .then((data) => {
                  const date = new Date();
                  date.setTime(date.getTime() + (60 * 60 * 1000));
                  const expires = '; expires=' + date.toUTCString();
                  document.cookie = `discount_code=${data.code}${expires}; path=/`;

                  // Applying Cookie
                  setTimeout(() => {
                    // Remove PDP Loader
                    document.querySelector('.xpresslane-button #gokwik-buy-now div').style.display = 'none';
                    document.querySelector('.xpresslane-button #gokwik-buy-now div').id = "btn-loader";
                    document.querySelector('.xpresslane-button #gokwik-buy-now').removeAttribute('disabled');
                  }, 2500);

                });

            }
            else {
              pdp_pop_last_str = "Save Using POPcoins";
              document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";

              // Remove PDP Loader
              document.querySelector('.xpresslane-button #gokwik-buy-now div').style.display = 'none';
              document.querySelector('.xpresslane-button #gokwik-buy-now div').id = "btn-loader";
              document.querySelector('.xpresslane-button #gokwik-buy-now').removeAttribute('disabled');

            }

            pdp_pop_div.querySelector('#buy-with-pop-coins-label').innerHTML = "Rs. " + pdp_curr_pop_price + ' | ' + pdp_pop_last_str;

          }

        });
    });

  }
}

// Cart and PDP Cookie Manage
function pop_pdp_disc_manage() {

  if (window.location.href.includes('/products') == true) {
    document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
    let pdp_pop = document.querySelector('.pdp_popcoin #buy-with-pop-coins');
    if (pdp_pop.checked == true) {
      pdp_pop.click();
    }

    let cart_pop_checked = document.querySelector('.pop_club_cart #buy-with-pop-coins');
    if (cart_pop_checked.checked == true) {
      cart_pop_checked.click();
    }

  }

}

// Opening the Modal
function openModel() {
  document.querySelector('#BackToTop').classList.remove('hidden');
  let key1 = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
  openLoadedIframe();
}

// PDP Quantity Change
function pdp_qty_fix() {
  document.querySelectorAll('.qtyField #quantity').forEach(function (el) {
    el.addEventListener('change', function () {

      let redeemCoins = parseInt(document.querySelector('#pop-club-data-coins').getAttribute('value'));
      let pdp_qty = parseInt(document.querySelector('.qtyField #quantity').value);
      let price = parseInt(document.querySelector('#pop-club-product-detail').getAttribute('price'));
      let pdp_max_coin = Math.min(Math.ceil(pdp_qty * parseInt(price) * 0.3), redeemCoins);

      let key = document.cookie
        .split('; ')
        .find((row) => row.startsWith('_shopify_s='))
        ?.split('=')[1];
      let pop_earn_price = Math.floor((parseInt(price)) / 100) * 5 * pdp_qty;
      let pop_pdp_msg = document.querySelector('#pop-club-product-detail #product-issuance-msg');
      pop_pdp_msg.innerHTML = "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://d20pzmflnl47dv.cloudfront.net/media/coin-flat.png' width='20' height='21'> </span> " + pop_earn_price + " on this product <img class='info-popup-coin' src='https://d20pzmflnl47dv.cloudfront.net/media/icon-i.png' onclick=openLoadedIframe()></p>";

      let is_pop_login = document.querySelector('#pop-club-login-flag').getAttribute('value');
      if (is_pop_login == 'true' && redeemCoins > 0) {
        let strip_new_str = '<span class="saaki_royal">POPcoins discount will be applied at the cart</span>';
        document.querySelector('#pop-club-quick-buy-span-stripe').innerHTML = strip_new_str;
        document.querySelector('.pdp_popcoin #buy-with-pop-coins-label').innerHTML = 'Save Rs. ' + pdp_max_coin + ' Using POPcoins';
        document.cookie = "discount_code=" + "; expires=Thu, 18 Dec 2000 12:00:00 UTC; path=/";
        document.querySelector('.pdp_popcoin #buy-with-pop-coins').checked = false;
      }
      else {
        document.querySelector('.pdp_popcoin').classList.add('hidden');
      }

    });
  });
}

function loadIframe() {
  const key = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
  let popclub_iframe_src;
  let modals = document.getElementById("myModal3");
  modals.style.opacity = 1;
  document.body.classList.add('popcoinShow');
    const iframeURL = document.querySelector('#pop-club-iframe-url').value;
    if (window.location.href.indexOf('/products/') != -1) {
      const redeemCoins =    document.querySelector('#pop-club-redeem-price').value;
      popclub_iframe_src = iframeURL + '?key=' + key + '&page=pdp&discount=' + redeemCoins;
    }
    else {
      let cartPage = '';
      if (window.location.href.indexOf('/cart') != -1) {
        cartPage = '&page=cart';
      }
      popclub_iframe_src = iframeURL + '?key=' + key + cartPage;
    }
    document.querySelector('#popupiframe2').src = popclub_iframe_src + '&url=' + window.location.href;
    console.log("iframe loaded");
}

function openLoadedIframe(){
  let modal = document.getElementById('myModal3');
  modal.style.display = 'block';
  document.body.classList.add('popcoinShow');
}

document.addEventListener("DOMContentLoaded", function () {
  // popPrices();
  checkout_input();
  pdp_qty_fix();
  loadIframe();
  
  document.querySelectorAll('.pop__coin-rewards').forEach((el) => {
    el.addEventListener('click', () => {
      let key1 = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];
      openLoadedIframe();
    });
  });
});